export default {
    shareReview: {
        title: 'Share Review',
        autoApproveHint: 'Submissions auto-approve after 48 hours by default',
        activityTime: 'Activity Period',
        empty: 'No share links pending review',
        tabs: {
            all: 'All',
            pending: 'Pending',
            unsubmitted: 'Unsubmitted',
            approved: 'Approved',
            rejected: 'Rejected',
        },
        columns: {
            uid: 'UID',
            platform: 'Platform',
            link: 'Link',
            code: 'Code',
            plays: 'Plays',
            likes: 'Likes',
            shares: 'Shares',
            submittedAt: 'Submitted At',
            autoApproveAt: 'Auto Approve At',
            status: 'Status',
            rejectReason: 'Reject Reason',
            action: 'Actions',
        },
        status: {
            pending: 'Pending',
            unsubmitted: 'Unsubmitted',
            approved: 'Approved',
            rejected: 'Rejected',
        },
        actions: {
            approve: 'Approve',
            reject: 'Reject',
            approveConfirm: 'Approve this share submission?',
            metrics: 'Edit Metrics',
        },
        rejectModal: {
            title: 'Reject Reason',
            hint: 'The user will be notified with this reason',
            reason: 'Reason',
            reasonRequired: 'Please enter a reject reason',
            ok: 'Confirm Reject',
        },
        metricsModal: {
            title: 'Edit Share Metrics',
        },
        finalize: {
            button: 'Finalize Activity Data',
            title: 'Finalize Activity Data',
            content:
                'Confirm all data is correct. After submit, rankings will be locked and can no longer be changed.',
            ok: 'Confirm',
            disabledHint: 'Available only after the activity ends',
        },
        toast: {
            approved: 'Approved',
            rejected: 'Rejected',
            metricsUpdated: 'Metrics updated',
            finalized: 'Activity finalized',
        },
        errors: {
            missingId: 'Missing share attempt id',
            missingActivityId: 'Missing activity id',
        },
    },
};
